import React from "react";
import {
  Container,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";
import ScoreSlider from "hearing/assets/digits/score-slider";
import {P1, P2, P3} from 'assets/fonts';


class Questions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: ["I think my hearing in general is", "I think my hearing in quiet is",
        "I think my hearing in background noise is"],
      hearing: {},
      hearingAids: null
    };
  }

  validateHearing = () => {
    const { questions, hearing, hearingAids } = this.state;
    if (Object.keys(hearing).length !== questions.length || hearingAids === null) return false;
    return true;
  };

  handleSlider = (index, value) => {
    const { hearing, questions } = this.state;
    this.setState(() => {
      hearing[questions[index]] = value;
      return { hearing };
    });
  };

  renderButton = () => {
    const { questions, hearing, hearingAids } = this.state;
    if (questions.length === 0) {
      return null;
    } else if (this.validateHearing()) {
      return (
        <Button
          variant="contained"
          size="large"
          onClick={() => this.props.handleClick(hearing, hearingAids)}
          style={{
            color: "white", backgroundColor: "#107896",
            width: 200,
            marginBottom: 10,
          }}
        >
          OK
        </Button>
      );
    } else {
      return (
        <div>
          <Button
            variant="contained"
            size="large"
            style={{
              width: 200,
              marginBottom: 10,
              color: "white", backgroundColor: "#107896"
            }}
            disabled={true}
          >
            OK
          </Button>
          <P3>You cannot progress to the next step because you have not completed the questions.</P3>
        </div>
      );
    }
  };

  render() {
    const { hearing, questions } = this.state;
    return (
      <Container>
        <div
          style={{
            position: "relative",
            marginTop: "5%",
            marginBottom: "5%",
            marginLeft: "10%",
            marginRight: "10%",
          }}
        >
          <P2>Please answer each of the questions below by moving the slider bar.</P2>
          <br />
          {questions.map((question, index) => {
            return (
              <div style={{ marginTop: 10 }}>
                <P2>{question}</P2>
                {hearing[questions[index]] &&
                  hearing[questions[index]].wellness ? null : (
                    <P3 className="text-danger">* must provide value</P3>
                  )}
                <div className="row">
                  <P3 style={{ marginTop: 10, marginLeft: 15 }}>
                    Bad
                  </P3>
                  <P3 style={{ marginTop: 10, marginLeft: "20%" }}>
                    Fair
                  </P3>
                  <P3 style={{ marginTop: 10, marginLeft: "20%" }}>
                    Excellent
                  </P3>
                </div>
                <ScoreSlider
                  handleScore={(value) => this.handleSlider(index, value)}
                  style={{ marginLeft: "30%" }}
                />
              </div>
            );
          })}
          <br />
          <FormControl component="fieldset" style={{ marginBottom: 10 }}>
            <P2 component="legend">Do you wear or have you ever worn hearing aids?</P2>
            <RadioGroup
              row
              aria-label="position"
              name="position"
              defaultValue="top"
              onChange={(e) => this.setState({ hearingAids: e.target.value })}
            >
              <FormControlLabel
                value="yes"
                control={<Radio color="primary" />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio color="primary" />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          <br />
          {this.renderButton()}
        </div>
      </Container>
    );
  }
}

export default Questions;
